import {
  ExportButton,
  FilterButton,
  SelectColumnsButton,
  TopToolbar,
  usePermissions,
} from "react-admin";
import MyCreateButton from "../common/MyCreateButton";

const TableListActions = ({
  createHandler,
  exporter,
  filter,
  createPermission,
  extraActions = null,
}) => {
  const { permissions } = usePermissions();
  return (
    <TopToolbar
      sx={{
        minHeight: "54px !important",
        mb: 1,
        "& .MuiButtonBase-root": {
          border: "0.1rem solid",
        },
      }}
    >
      <SelectColumnsButton />
      {filter === false ? null : <FilterButton />}
      {extraActions}
      {(permissions.administrator || permissions[createPermission]) &&
      createHandler ? (
        <MyCreateButton
          // startIcon={<AddIcon />}
          label="ra.action.create"
          // sx={{ width: "fit-content" }}
          onClick={createHandler}
        />
      ) : null}
      {exporter === false ? null : <ExportButton />}
    </TopToolbar>
  );
};

export default TableListActions;
